// generateCartItemKey.js

// Genera un identificador único para cada entrada del carrito
const generateCartItemKey = (item, selectedExtras, selectedPrice) => {
  const extrasKey = selectedExtras
    .map((extra) => extra.id + (extra?.quantity??""))
    .sort()
    .join("-");
  return `${item.id}-${extrasKey}-${!!selectedPrice?selectedPrice:'single-price'}`;
};

export default generateCartItemKey;
